import React, { useContext } from "react";

export const ConfigContext = React.createContext<WebConfig>({
  graphqlAPI: "",
  appUrl: "",
  communityUrl: "",
  rudderstackURL: "",
  rudderstackWriteKeyWebApp: "",
  revision: "",
  oauthAppleRedirectUrl: "",
  oauthGoogleRedirectUrl: "",
  oauthLinkedinRedirectUrl: "",
  hubspotPortalId: "",
  API: "",
  environment: "",
  growthbookKey: "",
  googleApiKey: "",
  cookieDomain: "",
});
export interface WebConfig {
  graphqlAPI: string;
  appUrl: string;
  communityUrl: string;
  rudderstackURL: string;
  rudderstackWriteKeyWebApp: string;
  revision: string;
  oauthAppleRedirectUrl: string;
  oauthGoogleRedirectUrl: string;
  oauthLinkedinRedirectUrl: string;
  hubspotPortalId: string;
  API: string;
  environment: string;
  growthbookKey: string;
  googleApiKey: string;
  cookieDomain: string;
}

export const useConfig = () => useContext(ConfigContext);
